import { render, staticRenderFns } from "./createDocument.vue?vue&type=template&id=4e86d75a&scoped=true&"
import script from "./createDocument.vue?vue&type=script&lang=ts&"
export * from "./createDocument.vue?vue&type=script&lang=ts&"
import style0 from "./createDocument.vue?vue&type=style&index=0&id=4e86d75a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e86d75a",
  null
  
)

export default component.exports